export const serviceTypePermission = {
  async: false,
  validate: function(data: any) {
    data = data.original
    if (!data.service_type_id) return true
    if (!data.jobs?.length) return true

    const ngs = []
    for (const service_type_job of data.serviceType.jobs) {
      for (const job of data.jobs) {
        if (service_type_job.id == job) {
          ngs.push(`${service_type_job.code} - ${service_type_job.description}`)
        }
      }
    }
    if (ngs.length) {
      throw Error(
        `Tipo de serviço não permite as seguintes NGs ${ngs.toString()}`
      )
    }
    return true
  },
}
